module.exports = __webpack_public_path__ + "static/media/point_icon_12.39fc8eab.svg";